import 'viewerjs/dist/viewer.css';

import '../VtxImage/index.less';
